import { render, staticRenderFns } from "./NewLgbTeamMembersModify.vue?vue&type=template&id=502709d5"
import script from "./NewLgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./NewLgbTeamMembersModify.vue?vue&type=script&lang=js"
import style0 from "./NewLgbTeamMembersModify.vue?vue&type=style&index=0&id=502709d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports